'use strict';

const recommendationTemplate = require('../recommendation.html.mustache');

const smallWidgetTemplate = require('../small_widget.html.mustache');

Groupon.FollowMerchantModal = class FollowMerchantModal {
  constructor(el, data, csrf) {
    this.followMerchant = this.followMerchant.bind(this);
    this.unfollowMerchant = this.unfollowMerchant.bind(this);
    this.el = el;
    this.data = data;
    this.csrf = csrf;
    this.rootUrl = '/merchant-page';
    this.$modal = $(this.el);
    this.$modalFollowContainers = this.$modal.find('.follow-container');
    this.$modalRecommendationContainers = this.$modal.find(
      '.recommendation-container'
    );
    this.isMakingAPIRequest = {};
  }

  openModal() {
    this.addFollowAndRecommendationData(this.data);
    MPP.Modal.open('#follow-merchant-nearby-places-modal');
    GIG.Utils.truncateElements($('#follow-merchant-nearby-places-modal'));
    this.initModalBindings();
    return this.lazyLoadImages();
  }

  addFollowAndRecommendationData(data) {
    _.each(this.$modalFollowContainers, followContainer => {
      const $followContainer = $(followContainer);
      const closestPlaceCard = $followContainer.closest('.deal-card');
      const { placeId } = $(closestPlaceCard).data();

      const followData =
        data && data[placeId] && data[placeId]['follow']
          ? data[placeId]['follow']
          : undefined;

      const templateData = {
        placeId,
        presentedFollowCount:
          (followData != null ? followData.presentedFollowCount : undefined) !=
          null
            ? followData != null
              ? followData.presentedFollowCount
              : undefined
            : '0',
      };

      templateData.translate = templateData.t = () => text =>
        I18n.translate(text);

      const html = smallWidgetTemplate.render(templateData);
      return $followContainer.html(html);
    });

    return _.each(
      this.$modalRecommendationContainers,
      recommendationContainer => {
        const $recommendationContainer = $(recommendationContainer);
        const closestPlaceCard = $recommendationContainer.closest('.deal-card');
        const { placeId } = $(closestPlaceCard).data();

        const recommendationData =
          data && data[placeId] && data[placeId]['recommendation']
            ? data[placeId]['recommendation']
            : undefined;

        if (
          !(recommendationData != null
            ? recommendationData.showToUser
            : undefined)
        ) {
          return null;
        }

        const templateData = {
          total: recommendationData.total,
          percentage: recommendationData.percentage,
        };
        const html = recommendationTemplate.render(templateData);
        return $recommendationContainer.html(html);
      }
    );
  }

  lazyLoadImages() {
    return this.$modal
      .find('.lazy-loaded-image')
      .each((position, imageElement) => {
        const $image = $(imageElement);
        return $image.attr('src', $image.attr('lazy-load-src'));
      });
  }

  initModalBindings() {
    this.$modalFollowButtons = this.$modalFollowContainers.find(
      '.follow-text-container'
    );
    this.$modalTextContainers = this.$modalFollowContainers.find(
      '.follow-count-container'
    );
    this.$modalUnfollowButtons = this.$modalFollowContainers.find(
      '.unfollow-text-container'
    );
    this.$modalTextContainers.click(this.followMerchant);
    this.$modalFollowButtons.click(this.followMerchant);
    return this.$modalUnfollowButtons.click(this.unfollowMerchant);
  }

  modalSwitchFollowingStatus($container) {
    $container.find('.unfollow-text-container').toggleClass('hide');
    $container.find('.follow-text-container').toggleClass('hide');
    return $container.find('.follow-count-container').toggleClass('hide');
  }

  followMerchant(e) {
    e.preventDefault();
    const {
      placeId,
      closestFollowContainer,
    } = this.getNecessaryClickInformation(e);
    return this.makeFollowAPICall(
      placeId,
      `${this.rootUrl}/follow-merchant`,
      $(closestFollowContainer)
    );
  }

  unfollowMerchant(e) {
    e.preventDefault();
    const {
      placeId,
      closestFollowContainer,
    } = this.getNecessaryClickInformation(e);
    return this.makeFollowAPICall(
      placeId,
      `${this.rootUrl}/follow-merchant/delete`,
      $(closestFollowContainer)
    );
  }

  getNecessaryClickInformation(e) {
    const $clickedButton = $(e.target);
    const closestFollowContainer = $clickedButton.closest('.follow-content');
    const closestPlaceCard = $clickedButton.closest('.deal-card');
    const { placeId } = $(closestPlaceCard).data();
    return {
      placeId,
      closestFollowContainer,
    };
  }

  makeFollowAPICall(placeId, url, $container) {
    if (this.isMakingAPIRequest[placeId]) {
      return null;
    }

    this.isMakingAPIRequest[placeId] = true;
    this.modalSwitchFollowingStatus($container);
    const obj = {
      _csrf: this.csrf,
      placeId,
    };
    return $.ajax({
      url,
      type: 'POST',
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify(obj),
      error: () => {
        return this.modalSwitchFollowingStatus($container);
      },
      complete: () => {
        this.isMakingAPIRequest[placeId] = false;
        return this.isMakingAPIRequest[placeId];
      },
    });
  }
};
